import { p as palette } from '../base/color-DMp1DFwP.js';
import { d as fontSizes, m as mobileFontSizes } from '../base/typography-j1qfCKl5.js';

const touchLink = {
  backgroundColor: palette.white,
  borderColor: palette.gray[200],
  borderRadius: '8px',
  color: palette.squidInk,
  iconColor: palette.gray[700],
  fontSize: fontSizes.base,
  group: {
    borderColor: palette.gray[200]
  }
};
const mobileTouchLink = {
  mobile: {
    fontSize: mobileFontSizes.base
  }
};

export { mobileTouchLink as m, touchLink as t };
//# sourceMappingURL=touchLink-CzpG8W70.js.map
